var _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAdmin = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Admin")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/solid/admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6666666,13.8333333 L15.6666666,7.49999996 C15.6666666,6.94771521 16.1143819,6.49999996 16.6666666,6.49999996 L31.3333333,6.49999996 C31.8856181,6.49999996 32.3333333,6.94771521 32.3333333,7.49999996 L32.3333333,13.8333333 L40.5,13.8333333 C41.0522847,13.8333333 41.5,14.2810486 41.5,14.8333333 L41.5,36.8333333 C41.5,37.3856181 41.0522847,37.8333333 40.5,37.8333333 L31.333653,37.8333333 L16.6666666,37.8333334 L7.49999996,37.8333333 C6.94771521,37.8333333 6.49999996,37.3856181 6.49999996,36.8333333 L6.49999996,14.8333333 C6.49999996,14.2810486 6.94771521,13.8333333 7.49999996,13.8333333 L15.6666666,13.8333333 Z M17.6666666,13.8333333 L30.3333333,13.8333333 L30.3333333,8.49999996 L17.6666666,8.49999996 L17.6666666,13.8333333 Z",
    id: "Shape",
    fill: "#0A1428",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAdmin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/admin.1abfc180.svg";
export { ForwardRef as ReactComponent };